import * as React from "react";
import { Divider } from "antd";
import { v4 as uuidv4 } from "uuid";
import { CpArrayObject } from "../../../gvc/testNewForm/CpArrayObject";
import { CpArrayItemRegistryMirror } from "./CpArrayItemRegistryMirror";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";

interface Props {}
export const AddonRegistryMirror: React.FC<Props> = ({}) => {
  const isEnabled = useCpFormValue(`addons.registryMirror.isEnabled`);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <Divider orientation="left" orientationMargin={0}>
        Add-On | Registry Mirror
      </Divider>
      <div id={`addon-registryMirror`} style={{ scrollMarginTop: 200 }}>
        <div style={{ maxWidth: 900 }}>
          <CpArrayObject
            name={`addons.registryMirror.mirrors`}
            label={`Mirrors`}
            labels={["Registry", "Mirror"]}
            factoryFn={() => ({ id: uuidv4(), registry: "", mirror: "" })}
          >
            <CpArrayItemRegistryMirror />
          </CpArrayObject>
        </div>
      </div>
    </>
  );
};
